import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import type { StorageOffersOverviewParams } from 'src/apis/storage/types';
import { usePublicStorageOffers } from 'src/apis/storage/use-public-storage-offers';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useStorageOffersPageParams } from 'src/pages/storage/offers-new/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageOffersOverviewNew: FC<Props> = ({ storageServiceRoot }) => {
  const pageParams = useStorageOffersPageParams();

  const params = useMemo((): StorageOffersOverviewParams => {
    return {
      sortBy: pageParams.value.sortBy,
      sortDirection: pageParams.value.sortDirection,
      limit: pageParams.value.pageSize,
      offset: pageParams.value.start,
      offerName: pageParams.value.offerName,
      offerBusinessId: pageParams.value.offerBusinessId,
      typeOfProduct: pageParams.value.typeOfProduct,
      runtimeStart: pageParams.value.productRuntimeStart,
      runtimeEnd: pageParams.value.productRuntimeEnd,
      offerStatus: pageParams.value.offerStatus,
      storageLocationId: pageParams.value.storageLocationId.map(
        (location) => location.value
      ),
      ssoOrganisationId: pageParams.value.ssoOrganisationId.map(
        (sso) => sso.value
      ),
      offersWithAllocations: pageParams.value.offersWithAllocations,
    };
  }, [pageParams.value]);

  const storageOffers = usePublicStorageOffers({
    storageServiceRoot,
    params,
  });

  if (!storageOffers.response) {
    return <PageSpinner />;
  }

  return (
    <Page
      storageServiceRoot={storageServiceRoot}
      storageOffers={storageOffers}
      pageParams={pageParams}
    />
  );
};
